export const FETCH_MASTER_CURRENCIES_DDL = "FETCH_MASTER_CURRENCIES_DDL";
